(() => {
  const copy = document.documentElement.dataset;
  const wishlistKey = 'ninja-slushi-wishlist-v1';
  const productUrl = value => {
    try {const url=new URL(value,location.origin);return url.origin===location.origin&&url.pathname.includes('/products/')?url.pathname+url.search:'';} catch {return '';}
  };
  const imageUrl = value => {
    if(typeof value!=='string'||!value)return '';
    try {const url=new URL(value,location.origin);return url.origin===location.origin||url.protocol==='https:'?url.href:'';} catch {return '';}
  };
  let wishlist = [];
  try {
    const stored=JSON.parse(localStorage.getItem(wishlistKey)||'[]');
    if(Array.isArray(stored))wishlist=stored.filter(item=>item&&item.id&&typeof item.title==='string'&&productUrl(item.url)).map(item=>({id:String(item.id),title:item.title,url:productUrl(item.url),image:imageUrl(item.image),price:typeof item.price==='string'?item.price:''}));
  } catch {}
  const saveWishlist = () => {try {localStorage.setItem(wishlistKey,JSON.stringify(wishlist));} catch {}};
  const currentWishlistProduct = () => {
    const data=document.querySelector('[data-wishlist-product]')?.dataset;
    if(!data?.productId||!productUrl(data.url))return null;
    return {id:String(data.productId),title:data.title,url:productUrl(data.url),image:imageUrl(data.image),price:data.price};
  };
  const renderWishlist = () => {
    const product=currentWishlistProduct();
    const selected=Boolean(product&&wishlist.some(item=>item.id===product.id));
    document.querySelectorAll('[data-wishlist]').forEach(button=>{button.disabled=!product;button.setAttribute('aria-pressed',String(selected));button.classList.toggle('is-selected',selected);});
    document.querySelectorAll('[data-header-wishlist]').forEach(button=>button.classList.toggle('is-selected',wishlist.length>0));
    document.querySelectorAll('[data-wishlist-dialog]').forEach(dialog=>{
      const list=dialog.querySelector('[data-wishlist-list]');
      list.replaceChildren();
      dialog.querySelector('[data-wishlist-empty]').hidden=wishlist.length>0;
      wishlist.forEach(item=>{
        const card=document.createElement('li');card.className='wishlist-item';
        const imageLink=document.createElement('a');imageLink.href=item.url;imageLink.className='wishlist-item__image';
        if(item.image){const image=document.createElement('img');image.src=item.image;image.alt=item.title;image.width=100;image.height=100;image.loading='lazy';imageLink.append(image);}
        const details=document.createElement('div');details.className='wishlist-item__details';
        const title=document.createElement('a');title.href=item.url;title.className='wishlist-item__title';title.textContent=item.title;
        const price=document.createElement('p');price.className='wishlist-item__price';price.textContent=item.price;
        const controls=document.createElement('div');controls.className='wishlist-item__actions';
        const view=document.createElement('a');view.href=item.url;view.className='button button--primary';view.textContent=dialog.dataset.viewLabel;
        const remove=document.createElement('button');remove.type='button';remove.className='wishlist-item__remove';remove.textContent=dialog.dataset.removeLabel;
        remove.addEventListener('click',()=>{wishlist=wishlist.filter(saved=>saved.id!==item.id);saveWishlist();renderWishlist();dialog.querySelector('[data-close-wishlist]').focus();});
        controls.append(view,remove);details.append(title,price,controls);card.append(imageLink,details);list.append(card);
      });
    });
  };
  const toggleWishlist = () => {
    const product=currentWishlistProduct();
    if(!product)return;
    if(wishlist.some(item=>item.id===product.id))wishlist=wishlist.filter(item=>item.id!==product.id);else wishlist.push(product);
    saveWishlist();renderWishlist();
  };
  const initWishlist = root => {
    root.querySelectorAll('[data-wishlist-dialog]').forEach(dialog=>{
      if(dialog.dataset.ready)return;dialog.dataset.ready='true';
      let returnFocus;
      dialog.querySelector('[data-close-wishlist]').addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
      dialog.addEventListener('close',()=>returnFocus?.focus());
      document.querySelectorAll(`[data-header-wishlist][aria-controls="${dialog.id}"]`).forEach(button=>button.addEventListener('click',()=>{returnFocus=button;renderWishlist();if(!dialog.open)dialog.showModal();}));
    });
    const product=currentWishlistProduct();
    if(product&&wishlist.some(item=>item.id===product.id)){wishlist=wishlist.map(item=>item.id===product.id?product:item);saveWishlist();}
    renderWishlist();
  };
  const initNavigation = root => {
    root.querySelectorAll('[data-site-header]').forEach(header=>{
      if(header.dataset.navigationReady)return;header.dataset.navigationReady='true';
      header.querySelectorAll('.header-nav__dropdown').forEach(menu=>menu.addEventListener('toggle',()=>{if(menu.open)menu.closest('ul').querySelectorAll(':scope > li > .header-nav__dropdown').forEach(other=>{if(other!==menu)other.open=false;});}));
      header.addEventListener('keydown',event=>{if(event.key==='Escape'){const openMenu=event.target.closest('details[open]');if(openMenu){openMenu.open=false;openMenu.querySelector('summary').focus();event.stopPropagation();}}});
      document.addEventListener('click',event=>{if(!header.contains(event.target))header.querySelectorAll('details[open]').forEach(menu=>{menu.open=false;});});
    });
  };
  const initProduct = section => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const slides = [...section.querySelectorAll('[data-gallery-slide]')];
    const thumbs = [...section.querySelectorAll('[data-gallery-thumb]')];
    const dots = section.querySelector('[data-gallery-dots]');
    let active = 0;
    let requested = 0;
    let requestId = 0;
    const prepareSlide = async index => {
      const image = slides[index]?.querySelector('img');
      if (!image) return false;
      image.loading = 'eager';
      if (image.complete && image.naturalWidth > 0) return true;
      if (typeof image.decode === 'function') {
        try { await image.decode(); } catch { return image.complete && image.naturalWidth > 0; }
        return image.naturalWidth > 0;
      }
      return new Promise(resolve => {
        image.addEventListener('load', () => resolve(true), {once:true});
        image.addEventListener('error', () => resolve(false), {once:true});
      });
    };
    const setSlide = async index => {
      if (!slides.length) return;
      requested = (index + slides.length) % slides.length;
      const target = requested;
      const ticket = ++requestId;
      const ready = await prepareSlide(target);
      if (!ready || ticket !== requestId) return;
      active = target;
      slides.forEach((slide,i) => {slide.hidden = i !== active;slide.classList.toggle('is-active', i === active);});
      thumbs.forEach((thumb,i) => {thumb.classList.toggle('is-active', i === active);thumb.setAttribute('aria-pressed',String(i === active));});
      dots?.querySelectorAll('button').forEach((dot,i) => {dot.classList.toggle('is-active',i === active);dot.setAttribute('aria-pressed',String(i === active));});
      const activeDot=dots?.querySelector('.is-active');
      if(activeDot&&dots.clientWidth)dots.scrollTo({left:Math.max(0,activeDot.offsetLeft-(dots.clientWidth-activeDot.offsetWidth)/2),behavior:'auto'});
      prepareSlide((active + 1) % slides.length);
      prepareSlide((active - 1 + slides.length) % slides.length);
    };
    if (dots) slides.forEach((slide,i) => {const b = document.createElement('button');b.type='button';b.setAttribute('aria-label',`${copy.imageLabel || 'Produktbild'} ${i+1}`);b.addEventListener('click',()=>setSlide(i));dots.append(b);});
    setSlide(0);
    thumbs.forEach((thumb,i) => thumb.addEventListener('click',()=>setSlide(i)));
    section.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>setSlide(requested-1));
    section.querySelector('[data-gallery-next]')?.addEventListener('click',()=>setSlide(requested+1));
    const stage = section.querySelector('.gallery-stage');
    let touchStart;
    stage?.addEventListener('touchstart', event => {
      touchStart = event.touches.length === 1 ? {x:event.touches[0].clientX,y:event.touches[0].clientY} : undefined;
    }, {passive:true});
    stage?.addEventListener('touchend', event => {
      if (!touchStart || event.touches.length) { touchStart = undefined; return; }
      const point = event.changedTouches[0];
      const dx = point.clientX - touchStart.x;
      const dy = point.clientY - touchStart.y;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.25) setSlide(requested + (dx < 0 ? 1 : -1));
      touchStart = undefined;
    }, {passive:true});
    stage?.addEventListener('touchcancel', () => { touchStart = undefined; }, {passive:true});
    section.querySelector('[data-read-more]')?.addEventListener('click',e=>{const expanded=section.querySelector('[data-benefits]').classList.toggle('is-expanded');e.currentTarget.setAttribute('aria-expanded',String(expanded));e.currentTarget.textContent=expanded?(copy.lessLabel||'Weniger lesen'):(copy.moreLabel||'Mehr lesen');});
    section.querySelector('[data-quantity-minus]')?.addEventListener('click',()=>{const input=section.querySelector('input[name="quantity"]');input.value=Math.max(1,Number(input.value||1)-1);input.dispatchEvent(new Event('change',{bubbles:true}));});
    section.querySelector('[data-quantity-plus]')?.addEventListener('click',()=>{const input=section.querySelector('input[name="quantity"]');input.value=Math.max(1,Number(input.value||1))+1;input.dispatchEvent(new Event('change',{bubbles:true}));});
    section.querySelector('input[name="quantity"]')?.addEventListener('change',e=>{e.target.value=Math.max(1,Math.floor(Number(e.target.value)||1));});
    section.querySelector('[data-wishlist]')?.addEventListener('click',toggleWishlist);
    const form = section.querySelector('[data-product-form]');
    const addButtons = [...section.querySelectorAll('[data-add-to-cart],[data-sticky-add]')];
    let addInFlight = false;
    let variantAvailable = Boolean(form && !form.querySelector('[data-add-to-cart]')?.disabled);
    const setAddBusy = busy => {
      addInFlight = busy;
      addButtons.forEach(button => {
        button.disabled = busy || !variantAvailable;
        if (busy) button.setAttribute('aria-busy','true');
        else button.removeAttribute('aria-busy');
      });
    };
    section.querySelector('[data-sticky-add]')?.addEventListener('click',()=>{if(!addInFlight&&variantAvailable)form?.requestSubmit();});
    section.querySelector('[data-variant-select]')?.addEventListener('change',e=>{const opt=e.target.selectedOptions[0];section.querySelector('[data-product-price]').textContent=opt.dataset.price;section.querySelector('[data-sticky-price]').textContent=opt.dataset.price;variantAvailable=opt.dataset.available==='true';setAddBusy(addInFlight);const compare=section.querySelector('[data-compare-price]');if(compare)compare.textContent=opt.dataset.compare;});
    form?.addEventListener('submit',async e=>{
      e.preventDefault();
      if(addInFlight||!variantAvailable)return;
      const status=form.querySelector('[data-form-status]');
      const body=new FormData(form);
      setAddBusy(true);status.textContent=copy.addingLabel||'Wird hinzugefügt…';
      try {
        const result=await fetch(`${window.Shopify?.routes?.root||'/'}cart/add.js`,{method:'POST',headers:{Accept:'application/json'},body});
        const payload=await result.json().catch(()=>null);
        if(!result.ok)throw new Error(payload?.description||payload?.message||copy.cartError||'Der Artikel konnte nicht hinzugefügt werden.');
      } catch(error) {
        status.textContent=error.message||copy.cartError||'Der Artikel konnte nicht hinzugefügt werden.';
        setAddBusy(false);
        return;
      }
      status.textContent=copy.addedLabel||'Zum Warenkorb hinzugefügt';
      try {
        showCartNotice();
        try {
          const cartResponse=await fetch(`${window.Shopify?.routes?.root||'/'}cart.js`,{headers:{Accept:'application/json'}});
          if(cartResponse.ok){const cart=await cartResponse.json();if(Number.isInteger(cart.item_count))document.querySelectorAll('[data-cart-count]').forEach(b=>{b.textContent=cart.item_count;b.hidden=!cart.item_count;});}
        } catch {}
      } finally {setAddBusy(false);}
    });
  };
  const showCartNotice = () => {
    document.querySelector('.cart-notice')?.remove();
    const overlay=document.createElement('div');overlay.className='cart-notice';
    const panel=document.createElement('div');panel.className='cart-notice__panel';panel.setAttribute('role','dialog');panel.setAttribute('aria-modal','true');panel.setAttribute('aria-label',copy.addedLabel||'Zum Warenkorb hinzugefügt');
    const close=document.createElement('button');close.type='button';close.className='icon-button modal-close';close.textContent='×';close.setAttribute('aria-label',copy.closeLabel||'Schließen');
    const h2=document.createElement('h2');h2.textContent=copy.addedLabel||'Zum Warenkorb hinzugefügt';
    const link=document.createElement('a');link.href=`${window.Shopify?.routes?.root||'/'}cart`;link.className='button button--primary';link.textContent=copy.cartLabel||'Warenkorb ansehen';
    const continueButton=document.createElement('button');continueButton.type='button';continueButton.className='button button--outline';continueButton.textContent=copy.continueLabel||'Weiter einkaufen';
    panel.append(close,h2,link,continueButton);overlay.append(panel);document.body.append(overlay);
    const before=document.activeElement;
    const dismiss=()=>{overlay.remove();before?.focus();document.removeEventListener('keydown',keyboard);};
    const keyboard=e=>{if(e.key==='Escape')dismiss();if(e.key==='Tab'){const focusable=[close,link,continueButton];const index=focusable.indexOf(document.activeElement);if(e.shiftKey&&index===0){e.preventDefault();continueButton.focus();}if(!e.shiftKey&&index===2){e.preventDefault();close.focus();}}};
    close.addEventListener('click',dismiss);continueButton.addEventListener('click',dismiss);overlay.addEventListener('click',e=>{if(e.target===overlay)dismiss();});document.addEventListener('keydown',keyboard);close.focus();
  };
  const initReviews = section => {
    const widget=section.querySelector('[data-bv-show="reviews"]');
    if(widget){let ticks=0;const probe=setInterval(()=>{ticks++;const root=widget.shadowRoot||widget;if(root.querySelector('#reviews_container, [id^="bv-review-"], .bv-content-list')){section.querySelector('[data-review-snapshot]')?.setAttribute('hidden','');clearInterval(probe);}if(ticks>=60)clearInterval(probe);},500);}

    if(section.dataset.ready)return;section.dataset.ready='true';
    const list=section.querySelector('[data-review-list]');
    if(!list)return;
    const cards=[...list.querySelectorAll('.review-card')];let query='',rating=0,limit=4,sort='newest';
    const render=()=>{
      let matched=cards.filter(card=>(!rating||Number(card.dataset.rating)===rating)&&card.textContent.toLowerCase().includes(query));
      if(sort==='highest')matched.sort((a,b)=>Number(b.dataset.rating)-Number(a.dataset.rating));
      if(sort==='lowest')matched.sort((a,b)=>Number(a.dataset.rating)-Number(b.dataset.rating));
      if(sort==='newest')matched.sort((a,b)=>cards.indexOf(a)-cards.indexOf(b));
      cards.forEach(c=>{c.hidden=true;});matched.forEach((c,i)=>{list.append(c);c.hidden=i>=limit;});
      section.querySelector('[data-review-results]').textContent=`${Math.min(limit,matched.length)} ${copy.ofLabel||'von'} ${matched.length} ${copy.reviewsLabel||'übernommenen Bewertungen'}`;
      section.querySelector('[data-review-load-more]').hidden=limit>=matched.length;
    };
    section.querySelector('[data-review-search]')?.addEventListener('input',e=>{query=e.target.value.toLowerCase();limit=4;render();});
    section.querySelector('[data-review-sort]')?.addEventListener('change',e=>{sort=e.target.value;render();});
    section.querySelector('[data-review-load-more]')?.addEventListener('click',()=>{limit+=4;render();});
    section.querySelectorAll('[data-rating-filter]').forEach(b=>b.addEventListener('click',()=>{rating=rating===Number(b.dataset.ratingFilter)?0:Number(b.dataset.ratingFilter);section.querySelectorAll('[data-rating-filter]').forEach(t=>t.classList.toggle('is-active',Number(t.dataset.ratingFilter)===rating));limit=4;render();}));
    section.querySelectorAll('[data-review-keyword]').forEach(b=>b.addEventListener('click',()=>{query=b.dataset.reviewKeyword;section.querySelector('[data-review-search]').value=query;rating=0;limit=4;render();}));render();
  };
  const initSwipeCarousel = carousel => {
    if (carousel.dataset.swipeReady) return;
    carousel.dataset.swipeReady = 'true';
    let gesture;
    carousel.addEventListener('pointerdown', event => {
      if (event.pointerType === 'mouse' || !event.isPrimary) return;
      gesture = {id:event.pointerId,x:event.clientX,y:event.clientY,left:carousel.scrollLeft,horizontal:false};
    });
    carousel.addEventListener('pointermove', event => {
      if (!gesture || event.pointerId !== gesture.id) return;
      const dx = event.clientX - gesture.x;
      const dy = event.clientY - gesture.y;
      if (!gesture.horizontal) {
        if (Math.abs(dy) > 10 && Math.abs(dy) >= Math.abs(dx)) { gesture = undefined; return; }
        if (Math.abs(dx) < 10 || Math.abs(dx) <= Math.abs(dy) * 1.25) return;
        gesture.horizontal = true;
        carousel.classList.add('is-swiping');
        carousel.setPointerCapture(event.pointerId);
      }
      event.preventDefault();
      carousel.scrollLeft = gesture.left - dx;
    });
    const finish = event => {
      if (!gesture || event.pointerId !== gesture.id) return;
      const moved = gesture.horizontal;
      gesture = undefined;
      carousel.classList.remove('is-swiping');
      if (!moved) return;
      const cards = [...carousel.querySelectorAll(':scope > article')];
      const card = cards.reduce((nearest, item) => {
        const distance = Math.abs(item.getBoundingClientRect().left - carousel.getBoundingClientRect().left);
        const nearestDistance = nearest ? Math.abs(nearest.getBoundingClientRect().left - carousel.getBoundingClientRect().left) : Infinity;
        return distance < nearestDistance ? item : nearest;
      }, null);
      if (card) carousel.scrollBy({left:card.getBoundingClientRect().left-carousel.getBoundingClientRect().left,behavior:'smooth'});
    };
    carousel.addEventListener('pointerup', finish);
    carousel.addEventListener('pointercancel', event => {
      if (gesture?.id === event.pointerId) { gesture = undefined; carousel.classList.remove('is-swiping'); }
    });
  };
  const init = root => {
    initWishlist(root);initNavigation(root);
    root.querySelectorAll('.feature-carousel,.technology-grid').forEach(initSwipeCarousel);
    root.querySelectorAll('[data-product-section]').forEach(initProduct);root.querySelectorAll('[data-reviews-section]').forEach(initReviews);
    root.querySelectorAll('[data-carousel]').forEach(carousel=>{const controls=carousel.nextElementSibling;controls?.querySelector('[data-carousel-prev]')?.addEventListener('click',()=>carousel.scrollBy({left:-carousel.clientWidth*.75,behavior:'smooth'}));controls?.querySelector('[data-carousel-next]')?.addEventListener('click',()=>carousel.scrollBy({left:carousel.clientWidth*.75,behavior:'smooth'}));});
  };
  document.querySelector('.header-search-toggle')?.addEventListener('click',e=>{if(matchMedia('(min-width:990px)').matches){e.preventDefault();const search=document.querySelector('.header-search');search?.classList.toggle('is-open');search?.querySelector('input')?.focus();}});
  document.querySelectorAll('.footer-column h2').forEach(heading=>{heading.tabIndex=0;heading.addEventListener('click',()=>heading.parentElement.classList.toggle('is-open'));heading.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();heading.click();}});});
  window.addEventListener('storage',event=>{if(event.key!==wishlistKey)return;try {const stored=JSON.parse(event.newValue||'[]');if(Array.isArray(stored)){wishlist=stored.filter(item=>item&&item.id&&typeof item.title==='string'&&productUrl(item.url)).map(item=>({id:String(item.id),title:item.title,url:productUrl(item.url),image:imageUrl(item.image),price:typeof item.price==='string'?item.price:''}));renderWishlist();}} catch {}});
  init(document);document.addEventListener('shopify:section:load',event=>init(event.target));
})();
